import PdfService from './PdfService';

export default PdfService;


// WEBPACK FOOTER //
// ./src/Services/Pdf/index.ts